<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import StepWrapper from './StepWrapper.vue'

export default defineComponent({
  name: 'ScaleStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    scale: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: ['update:scale', 'click:prev', 'click:next'],

  setup(_, { emit }) {
    const SCALES = inject<string[]>('SCALES')!

    const next = () => {
      emit('click:next')
    }

    return {
      // constants
      SCALES,

      // methods
      next,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="scale"
    category-label="従業員数"
    :category-items="SCALES"
    @update:model-value="$emit('update:scale', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
